import { Component, effect, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ToastModule } from 'primeng/toast';
import { BinderSiteComponent } from './components/site.component';
import { EventsComponent } from './components/events.component';
import { DesignCriteriaComponent } from './components/design-criteria.component';
import { FloatingTotalComponent } from './components/floating-total.component';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CommonModule } from '@angular/common';
import { ApprovalBannerComponent } from './components/binder.approval-banner.component';
import { BinderMenuComponent } from './components/binder.menu.component';
import { BinderClientsComponent } from './components/binder.clients.component';
import { BinderFinancingComponent } from './components/binder.financing.component';
import { BinderTotalsComponent } from './components/binder.totals.component';
import { BinderAssembliesComponent } from './components/assemblies/assemblies.component';
import { BinderService } from '@/services/api/binder.service';
import { TaxDataService } from '@/services/app/tax-data.service';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { SignHistoryService } from '@/services/app/sign-history.service';
import { ActivatedRoute } from '@angular/router';
import { DynamicDrawerComponent } from '@/global/dynamic-drawer.component';

@Component({
    selector: 'app-landmark-binder',
    imports: [
      ToastModule, 
      ApprovalBannerComponent, 
      BinderMenuComponent, 
      BinderSiteComponent, 
      BinderClientsComponent, 
      EventsComponent, 
      DesignCriteriaComponent, 
      BinderFinancingComponent, 
      BinderTotalsComponent, 
      FloatingTotalComponent, 
      BinderAssembliesComponent,
      ButtonModule,
      ConfirmDialogModule,
      CommonModule,
      DynamicDrawerComponent
    ],
    template: `
<div class="grid grid-cols-12 gap-4 px-4 pb-24">
        <div class="col-span-12">
          <p-toast />
        
        <app-approval-banner class="mb-2"></app-approval-banner>
        </div>
        <div class="col-span-12">
        <app-binder-menu></app-binder-menu>
        </div>
        <div class="col-span-12 flex flex-col block lg:hidden">
        <app-binder-site></app-binder-site>
        <app-binder-clients [combine]="false" [showEditButton]="true"></app-binder-clients>
      </div>
        <div class="col-span-12 lg:col-span-8 flex flex-col gap-4">
        <app-binder-assemblies></app-binder-assemblies>
        </div>
        <div class="col-span-12 lg:col-span-4 flex flex-col gap-4">
        <div class="hidden lg:block">
        <app-binder-site class="mb-4"></app-binder-site>
        <app-binder-clients [combine]="false" [showEditButton]="true"></app-binder-clients>
      </div>
            <app-events
                *ngIf="currentBinderService.currentBinder().ProjectStatus > 6 || currentBinderService.currentBinder().ES_Hash !== null"></app-events>
                <app-design-criteria></app-design-criteria>
      <app-binder-financing></app-binder-financing>
      <app-binder-totals></app-binder-totals>
      <app-floating-total></app-floating-total>
      <app-dynamic-drawer></app-dynamic-drawer>
        </div>
    </div>
<p-confirmdialog />
    `
})
export class BinderComponent implements OnDestroy {
  constructor(
    public currentBinderService: BinderService,
    private taxDataService: TaxDataService,
    private binderDialogService: BinderDialogService,
    private signHistoryService: SignHistoryService,
    private titleService: Title,
    private route: ActivatedRoute
  ) {
    // Subscribe to route parameter changes
    this.route.params.subscribe(params => {
      const binderId = +params['binderId'];
      if (binderId) {
        // Trigger your logic here when binderId changes
        console.log('Binder ID changed:', binderId);
        this.currentBinderService.loadBinder(binderId);
        // You can call your service methods here to load the binder data
      }
    });

    effect(() => {
      const id = this.currentBinderService.currentBinder().BinderID;
      const name = this.currentBinderService.currentBinder().ClientLastName;
      const hash = this.currentBinderService.currentBinder().ES_Hash;
      if(hash) {
        this.signHistoryService.getHistory(hash);
      }
      const error = this.taxDataService.taxError();
      if(error.showError) {
        this.binderDialogService.toggleDialog('', 'tax-error', true,'center',true);
      }
      if(id && name) {
        this.titleService.setTitle(id + ' - ' + name);
      }
    });
  }

  ngOnDestroy() {
    this.titleService.setTitle('Landmark');
  }
}

